import { extractYoutubeId, youtubeEmbedUrl } from '@/features/curriculum';

const LOOM_ID_RE = /^[A-Za-z0-9]{16,}$/;
const LOOM_HOSTS = new Set(['loom.com', 'www.loom.com']);
const LOOM_PATH_PREFIXES = ['/share/', '/embed/'];

/**
 * Loom share link → its embed URL, or `null` when no id can be extracted.
 * Anything unrecognized stays a plain link chip — the SPA never guesses an
 * iframe source (the prod CSP allowlists exactly YouTube-nocookie and Loom).
 */
export function loomEmbedUrl(value: string): string | null {
  let url: URL;
  try {
    url = new URL((value ?? '').trim());
  } catch {
    return null;
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
  if (!LOOM_HOSTS.has(url.hostname.toLowerCase())) return null;
  for (const prefix of LOOM_PATH_PREFIXES) {
    if (url.pathname.startsWith(prefix)) {
      const id = url.pathname.slice(prefix.length).split('/')[0] ?? '';
      return LOOM_ID_RE.test(id) ? `https://www.loom.com/embed/${id}` : null;
    }
  }
  return null;
}

/** The embed URL for a link artifact (YouTube or Loom), else `null`. */
export function artifactEmbedUrl(value: string): string | null {
  const youtubeId = extractYoutubeId(value);
  if (youtubeId) return youtubeEmbedUrl(youtubeId);
  return loomEmbedUrl(value);
}
